import { IChannelLLMTemplate } from '@/models/llmTemplate.model';
import { LLMTemplateFormFields, TLLMTemplateFormValues } from '@/modules/LLMTemplateCommon';

export const getLLMChannelTemplateInitialValues = (template?: IChannelLLMTemplate | null): TLLMTemplateFormValues => ({
  [LLMTemplateFormFields.CONTENT]: template?.content || '',
});
